import { defineStore } from 'pinia'
import { createPersistConfig, GLOBAL_KEY } from '@/store/PersistHelper'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: null,
    uid: null,
    username: null,
    role: null,
    expiresIn: null,
    logo: null,
    isAuthenticated: false,
    mtcCode: null,
    ruc: null,
    name: null,
    code: null,
    nameSede: null,
    companyId: null,
    plantId: null,
    address: null,
    codeEntity: null,

  }),

  actions: {
    login(userData) {

      this.token           = userData.token
      this.uid             = userData.uid
      this.username        = userData.username
      this.role            = userData.role
      this.expiresIn       = userData.expiresIn
      this.logo            = userData.logo
      this.mtcCode         = userData.mtcCode   ?? null
      this.isAuthenticated = !!userData.token

      this.ruc       = userData.ruc       ?? null
      this.name      = userData.name      ?? null
      this.code      = userData.code      ?? null
      this.nameSede  = userData.nameSede  ?? null
      this.companyId = userData.companyId ?? null
      this.plantId   = userData.plantId   ?? null
      this.address   = userData.address   ?? null
      this.codeEntity  = userData.codeEntity  ?? null
    },

    logout() {
      this.$reset()
      localStorage.removeItem(GLOBAL_KEY)
      window.location.href = '/auth/login'
    },
  },

  getters: {
    isLoggedIn:   (state) => state.isAuthenticated,
    getToken:     (state) => state.token,
    getRole:      (state) => state.role,
    getCompanyId: (state) => state.companyId,
    getUser: (state) => ({
      uid:       state.uid,
      username:  state.username,
      role:      state.role,
      logo:      state.logo,
      mtcCode:   state.mtcCode,
      ruc:       state.ruc,
      name:      state.name,
      code:      state.code,
      nameSede:  state.nameSede,
      companyId: state.companyId,
      plantId:   state.plantId,
      address:   state.address,
      codeEntity:  state.codeEntity,
    }),
  },

  persist: {
    ...createPersistConfig('auth'),
    afterRestore: ({ store }) => {
      if (store.token) store.isAuthenticated = true
    }
  },
})